export function isChildOf(element, parentElement){

    var parents = [];

    // Get matching parent elements
    for ( ; element && element !== document; element = element.parentNode ) {

        // Add matching parents to array
        parents.push(element);
    }

    return parents.indexOf(parentElement) >= 0;
}

var documentCallbacks = {};

function getWindowScrollPos(){

    var doc = document.documentElement;
    var left = (window.pageXOffset || doc.scrollLeft);
    var top = (window.pageYOffset || doc.scrollTop);

    return { left, top };
}


export default {

    inserted: function(el, binding, vNode){

        const component = vNode.context;
        const $root = component.$root.$el;

        var touchDownPosition = null;

        // Document callback
        const documentCb = function(e) {
            
            if(!document.body.contains(e.target) || !$root.contains(e.target) || isChildOf(e.target, el) || e.target == el){
                return;
            }

            if(touchDownPosition !== null){

                // Check touch offset
                const scroll = getWindowScrollPos();

                const xOffset = Math.abs(scroll.left - touchDownPosition.left);
                const yOffset = Math.abs(scroll.top - touchDownPosition.top);

                if(xOffset > 10 || yOffset > 10){
                    return;
                }
            }

            component[binding.expression](e);
            touchDownPosition = null;

        }.bind(component);

        const onTouchStart = function(){
            touchDownPosition = getWindowScrollPos();
        };

        const uniqueId = Math.random() * 100000;
        el.dataset.clickOutsideElementId = uniqueId;

        documentCallbacks[uniqueId] = [documentCb, onTouchStart];
        document.addEventListener('click', documentCb);
        document.addEventListener('touchend', documentCb);
        document.addEventListener('touchstart', onTouchStart);
    },

    unbind: function(el){

        const uniqueId = el.dataset.clickOutsideElementId;
        const callbacks = documentCallbacks[uniqueId];

        if(callbacks){

            document.removeEventListener('click', callbacks[0]);
            document.removeEventListener('touchend', callbacks[0]);
            document.removeEventListener('touchstart', callbacks[1]);
            delete documentCallbacks[uniqueId];
        }
    }
}